import { useMemo } from 'react';

import Vehicle from '@quick/assets/icons/form/vehicle.svg';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from '../FormDataContext';

import { CommonTitle } from './CommonTitle';

export function VehiclesTitle() {
  const { t } = useAppTranslation(['demand']);
  const { serviceType, cargoType } = useFormDataContext();
  const fields = useMemo(
    () =>
      !!serviceType?.additional_fields?.filter(
        ({ field: { is_for_offer } }) => is_for_offer
      ).length,
    [serviceType]
  );
  const requiresVehicle = serviceType?.req_vehicle;

  if (
    !fields &&
    (!requiresVehicle || (cargoType?.vehicle_types?.length ?? 0) <= 1)
  )
    return null;
  const title = t(
    !fields && requiresVehicle ? 'demand:vehicle' : 'demand:accesorials'
  );
  return <CommonTitle title={title} Icon={Vehicle} />;
}
